/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1168
 */

var r = require(/* 2472 */"./2472")
var i = require(/* 538 */"../../../../../../797/101/2466/2467/538")
var /* [auto-meaningful-name] */Object$prototype = Object.prototype
var /* [auto-meaningful-name] */Object$prototype$hasOwnProperty = Object$prototype.hasOwnProperty
var /* [auto-meaningful-name] */Object$prototype$propertyIsEnumerable = Object$prototype.propertyIsEnumerable
var c = r(function () {
  return arguments
}()) ? r : function (e) {
    return i(e) && Object$prototype$hasOwnProperty.call(e, "callee") && !Object$prototype$propertyIsEnumerable.call(e, "callee")
  }
module.exports = c
